import PropTypes from 'prop-types';
import React, { Component } from 'react';

import BaseMeta from './BaseMeta';
import OpenGraphMeta from './OpenGraphMeta';
import TwitterMeta from './TwitterMeta';

const BASE_TITLE = 'Atlassian Marketplace';

export default class Meta extends Component {
  static propTypes = {
    canonicalUrl: PropTypes.string,
    description: PropTypes.string,
    image: PropTypes.string,
    openGraphImage: PropTypes.string,
    title: PropTypes.string,
    twitterImage: PropTypes.string,
  };

  render() {
    const title = this.props.title ? `${this.props.title} | ${BASE_TITLE}` : BASE_TITLE;
    return (
      <div>
        <BaseMeta
          canonicalUrl={this.props.canonicalUrl}
          description={this.props.description}
          title={title}
        />
        <OpenGraphMeta
          canonicalUrl={this.props.canonicalUrl}
          description={this.props.description}
          image={this.props.openGraphImage || this.props.image}
          title={title}
        />
        <TwitterMeta
          description={this.props.description}
          image={this.props.twitterImage || this.props.image}
          title={title}
        />
      </div>
    );
  }
}
